<template lang="pug">
ul.footer__menu-list
  li.footer__menu-list-item(v-for='(item, index) in list', :key='index')
    ext-link.menu-nav(
      v-if='item.to',
      v-bind='item',
      @click='$emit(item.event, $event)'
    )
    span.menu-text(v-else) {{ item.text }}
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';

export default {
  components: {
    ExtLink,
  },
  props: {
    list: Array,
  },
};
</script>

<style lang="stylus" scoped>
.footer__menu-list
    display: inline-block;
    vertical-align: top;
    list-style-type: none;

.footer__menu-list-item
    margin-bottom: 6px;

.menu-nav
.menu-text
    color: #485b84;
    text-decoration: none;
    font-size: 14px;

.menu-nav
    &:hover
        color: #51acff;
        text-decoration: underline;
</style>



// WEBPACK FOOTER //
// Footer.vue?b7e6e782